module.exports = function () {
    return function (deliverySaverPlan = {}) {
        if (deliverySaverPlan.BillingFrequencyDays === 0) {
            switch (deliverySaverPlan.BillingFrequencyMonths) {
                case 1: return 'Monthly payment amount';
                case 12: return 'Annual payment amount';
            }
        } else if (deliverySaverPlan.BillingFrequencyMonths === 0) {
            switch (deliverySaverPlan.BillingFrequencyDays) {
                case 1: return 'Daily payment amount';
                case 7: return 'Weekly payment amount';
            }
        }
        return 'Payment amount';
    };
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-payment-amount-heading.filter.js